"use client"

import { Check, Download } from "lucide-react"
import { useState } from "react"

export function DataExportButton({
  content,
  fileName,
  label,
  mediaType = "text/csv;charset=utf-8",
}: {
  content: string
  fileName: string
  label: string
  mediaType?: string
}) {
  const [downloaded, setDownloaded] = useState(false)

  function download() {
    const blob = new Blob([content], { type: mediaType })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = fileName
    link.click()
    URL.revokeObjectURL(url)
    setDownloaded(true)
    window.setTimeout(() => setDownloaded(false), 1_800)
  }

  return (
    <button type="button" className="button button-secondary" onClick={download}>
      {downloaded ? <Check aria-hidden="true" /> : <Download aria-hidden="true" />}
      {downloaded ? "Downloaded" : label}
    </button>
  )
}
